(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.apaspersoninformation === "undefined") {
        jQuery.extend(sm.portal.vm, { apaspersoninformation: {} });
    }

    function LoadModel(personInformation, container) {

        personInformation.ASN(container.Payload.BasicPerson.ASN);

        return personInformation;
    }

    function ExtractATO(personInformation) {

        return new smapi.community.PersonModel({
            GivenName: personInformation.FirstName(),
            MiddleName: personInformation.MiddleName(),
            Surname: personInformation.LastName(),
            PreferredGivenName: personInformation.PreferredName(),
            DateOfBirth: personInformation.DateOfBirth(),
            GenderID: personInformation.GenderID(),
            SIN: personInformation.SIN(),
            ID: personInformation.ID(),
            SuffixID: -1,
            CRMRankID: -1,
            LeadTypeID: -1
        });
    }

    function ExtractASNATO(personInformation) {

        return new smapi.community.PersonIdentifierModel({
            Identifier: personInformation.ASN()
        });
    }

    jQuery.extend(true, sm.portal.vm.apaspersoninformation, {
        LoadModel: LoadModel,
        ExtractATO: ExtractATO,
        ExtractASNATO: ExtractASNATO
    });

})(jQuery);
